export class AwsAgentCoreResourceSummary {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "arn",
            "baseName": "arn",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "parentId",
            "baseName": "parentId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsAgentCoreResourceSummary.attributeTypeMap;
    }
    constructor() {
    }
}
